export const mbcBulkEntryModule = 'mbcBulkEntry';
